"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBasketSharing = void 0;
var _analyticsData = require("@ori/analytics-data");
var _sharingPanel = require("@ori/sharing-panel");
var _react = require("react");
var _logger = require("../logger");
var _utils = require("../utils");
var _useTranslations = require("./useTranslations");
const useBasketSharing = ({
  isSharingButtonActive
}) => {
  const [isPanelOpen, setIsPanelOpen] = (0, _react.useState)(false);
  const [isCopyLinkOpen, setIsCopyLinkOpen] = (0, _react.useState)(false);
  const [sharedContent, setSharedContent] = (0, _react.useState)({});
  const [link, setLink] = (0, _react.useState)('');
  const isPopupOpen = isPanelOpen || isCopyLinkOpen;
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const onShareButtonClick = (0, _react.useCallback)(async () => {
    (0, _logger.logDebug)('onShareButtonClick()');
    try {
      const data = await (0, _utils.getSharedContent)();
      setSharedContent(data);
      setIsPanelOpen(true);
    } catch (error) {
      (0, _utils.showErrorNotification)(_utils.translationKeys.genericError);
      _logger.mainLogger.error(error, {
        action: 'onShareButtonClick'
      });
    }
  }, []);
  const onClose = (0, _react.useCallback)(() => {
    (0, _logger.logDebug)('Closing sharing wrapper ...');
    setIsPanelOpen(false);
    setIsCopyLinkOpen(false);
  }, []);
  const onError = (0, _react.useCallback)(() => {
    onClose();
    (0, _utils.showErrorNotification)(_utils.translationKeys.genericError);
  }, [onClose]);
  const onCopyLink = (0, _react.useCallback)((vendor, finalSharedLink) => {
    (0, _logger.logDebug)('onCopyLink()', {
      finalSharedLink,
      vendor
    });
    setLink(finalSharedLink);
    setIsCopyLinkOpen(true);
  }, []);
  const onShareIconClick = (0, _react.useCallback)(async vendor => {
    (0, _logger.logDebug)('onShareIconClick handler called.');
    // close sharing popup
    onClose();
    // always monitor user intentions even when the checks later will fail
    (0, _utils.triggerShareItemClickEvent)({
      contentType: _analyticsData.ContentType.ProductList,
      method: vendor,
      placement: _analyticsData.Placement.Minibag
    });
    // start the sharing process
    void (0, _sharingPanel.share)({
      onCopyLink,
      onError,
      sharedContent,
      vendor
    });
  }, [onClose, onCopyLink, onError, sharedContent]);
  const {
    ShareUrlAndText
  } = _sharingPanel.SharingCapability;
  const panelProps = {
    // sharing capabilities filter so far hard-coded here
    capabilities: [ShareUrlAndText],
    captionText: formatMessage('shareWithBrandPartner'),
    isCopyLinkIconDisplayed: true,
    onError,
    onShareIconClick
  };
  const copyLinkPopupProps = {
    header: formatMessage('copyLink')
  };
  const sharePopupProps = {
    size: 'small'
  };
  const popupProps = {
    disableEnforceFocus: true,
    disableTransition: true,
    onClose,
    open: isPopupOpen,
    ownerState: {
      isCopyLinkOpen
    },
    ...(isCopyLinkOpen ? copyLinkPopupProps : sharePopupProps)
  };
  const copyLinkProps = {
    buttonText: formatMessage('copy'),
    copiedText: formatMessage('linkCopied'),
    link
  };
  return {
    copyLinkProps,
    isCopyLinkOpen,
    isPanelOpen,
    isPopupOpen,
    isSharingButtonActive,
    onShareButtonClick,
    panelProps,
    popupProps
  };
};
exports.useBasketSharing = useBasketSharing;
